import { reportarError } from '@/core/telemetria/reportarError'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const messageFormartError = (error: any): string => {
  if (error?.response === undefined && typeof error === 'string') {
    return error
  }
  if (error?.response?.status < 500) {
    // 4XX
    if (
      error?.response?.data?.detail?.includes(
        'Response status code does not indicate success: 400 (Bad Request). ',
      )
    ) {
      return JSON.parse(
        error.response.data.detail.replace(
          'Response status code does not indicate success: 400 (Bad Request). ',
          '',
        ),
      ).detail
    }

    const errorMessage =
      error?.response?.data?.detail ??
      error?.response?.data?.error?.message ??
      error?.response?.data?.message ??
      error?.message

    return typeof errorMessage === 'string'
      ? errorMessage
      : JSON.stringify(errorMessage)
  }

  if (error?.response === undefined) {
    // La petición salió pero el servidor nunca respondió (sin conexión, timeout, CORS)
    if (error?.request !== undefined) {
      return 'No se pudo conectar con el servidor. Verifique su conexión a internet e intente nuevamente.'
    }

    // Error de JavaScript del propio frontend (TypeError, etc.); antes se disfrazaba
    // del mensaje de 5xx y mandaba al usuario a la mesa de ayuda por un bug de UI
    if (error instanceof Error) {
      reportarError(error, 'Error de aplicacion (no HTTP)')

      return `Ocurrió un error inesperado en la aplicación: ${error.message}`
    }
  }

  // 5XX
  return 'Espere un momento y vuelva a intentar. Si el problema persiste contacte a TI a través de la mesa de ayuda.'
}
